module.exports = __webpack_public_path__ + "img/news-fb-container-bg.0da86e8b.png";